module.exports = __webpack_public_path__ + "img/4.31110c6a.webp";